<template>
  <div :class="cursor">
    <div class="label_PFormSelect" v-if="label" @click="open">
      {{ label }}
      <b-icon
        id="input-cod-cliente-icon"
        icon="chevron-down"
        aria-hidden="true"
        v-if="variant == 'withoutBox' && !disabled"
      ></b-icon>
    </div>

    <ValidationProvider :rules="rules" v-slot="{ valid, errors }">
      <input
        type="text"
        v-model="selectedItemValue"
        v-show="false"
      /><!-- es solo para que el validationProvider vea los cambios-->
      <PDropDownContainer v-model="pussOption" :always-close="disabled">
        <template v-slot:content>
          <div :class="variantCop">
            <PIcon
              :icon="icon"
              :type="iType"
              :size="iSize"
              :color="iColor"
              v-if="icon"
              class="icon_PFormSelect"
            ></PIcon>
            <div v-b-tooltip.d300="placeholder !== selectedText ? selectedText : ''">
              {{ selectedText }}
            </div>
            <div :class="variantExpandCop" v-if="variant !== 'withoutBox'">
              <PIcon icon="expand_less" type="material" color="#ffd102" v-if="pussOption"></PIcon>
              <PIcon icon="expand_more" type="material" color="#ffd102" v-else></PIcon>
            </div>
          </div>
        </template>

        <div class="optionsSelect_PFormSelect">
          <PFormInputText
            v-model="valueSearch"
            v-if="pussOption && options.length > 5"
            icon="search"
            itype="material"
            class="p_input_search"
            ref="inputSearch"
          />
          <div
            v-for="(option, index) in optionsFiltering"
            :key="index"
            @click="selectItem(option[optionValue])"
            :class="giveMeClass(option[optionValue])"
          >
            {{ option[optionText] }}
          </div>
        </div>
      </PDropDownContainer>
      <div
        class="p_form_invalid_feedback"
        v-if="!(errors[0] ? false : valid ? true : null) && invalid_feedback"
      >
        {{ invalid_feedback }}
      </div>
      <div
        class="p_form_invalid_feedback"
        v-if="!(errors[0] ? false : valid ? true : null) && !invalid_feedback"
      >
        {{ $t(errors[0]) }}
      </div>
    </ValidationProvider>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PDropDownContainer from "../PDropDownContainer/PDropDownContainer.vue";
import PIcon from "../PIcon/PIcon.vue";
import PFormInputText from "../PFormInput/PFormInputText.vue";

@Component({
  components: {
    PDropDownContainer,
    PIcon,
  },
})
export class PFormSelect extends Vue {
  @Prop({ required: true }) value!: unknown;

  @Watch("value", { immediate: true, deep: true })
  onChangeValue(): void {
    if (this.valueAsArray) {
      this.selectedItemValue = (this.value as unknown[])?.length
        ? structuredClone((this.value as unknown[])[0])
        : null;
    } else {
      this.selectedItemValue = structuredClone(this.value);
    }
  }

  @Prop({ required: true }) options!: Record<string, unknown>[];
  @Prop({ required: false, default: "value" }) optionValue!: string;
  @Prop({ required: false, default: "text" }) optionText!: string;
  @Prop({ required: false, default: "" }) label!: string;
  @Prop({ required: false, default: "Select an option" }) placeholder!: string;
  @Prop({ required: false, default: "primary" }) variant!: "primary" | "button" | "withoutBox";
  @Prop({ required: false, default: "" }) icon!: string;
  @Prop({ required: false, default: "" }) iType!: string;
  @Prop({ required: false, default: 16 }) iSize!: number;
  @Prop({ required: false, default: "#6f6f6f" }) iColor!: string;
  @Prop({ required: false, default: undefined }) rules!: string;
  @Prop({ required: false, default: "" }) invalid_feedback!: string;
  @Prop({ required: false, default: false }) disabled!: boolean;
  @Prop({ required: false, default: false }) valueAsArray!: boolean;
  @Watch("pussOption", { immediate: true, deep: true })
  onChangePussOption(): void {
    if (this.pussOption) {
      this.$nextTick(() => {
        (this.$refs.inputSearch as PFormInputText)?.$el.querySelector("input")?.focus();
      });
    } else {
      this.valueSearch = "";
    }
  }

  selectedItemValue: unknown = null;
  pussOption = false;
  valueSearch = "";

  mounted(): void {
    this.selectItem(this.selectedItemValue);
  }

  get optionsFiltering(): any[] {
    return this.options.filter(
      (opt: any) =>
        opt[this.optionText].toLowerCase().includes(this.valueSearch.toLowerCase()) ||
        opt[this.optionText]
          .toLowerCase()
          .normalize("NFD")
          .replaceAll(/\p{Diacritic}/gu, "")
          .includes(this.valueSearch.toLowerCase())
    );
  }

  get variantCop(): string {
    let returnTemp: string = "inputSelect_PFormSelect_" + this.variant;
    if (this.variant === "button" && this.selectedItemValue != "") {
      returnTemp = returnTemp + " borderSelected_PFormSelect";
    }
    return returnTemp;
  }

  get variantExpandCop(): string {
    return "expand_moreSelect_PFormSelect_" + this.variant;
  }

  get cursor(): string {
    return this.disabled ? "containerSelect_PFormSelect disabled" : "containerSelect_PFormSelect";
  }

  get selectedText(): unknown {
    const optionFind = this.options.find((opt) => opt[this.optionValue] == this.selectedItemValue);
    if (optionFind) {
      return optionFind[this.optionText];
    } else {
      return this.placeholder;
    }
  }

  selectItem(itemValue: unknown): void {
    let val;
    if (this.valueAsArray) {
      val = itemValue !== null && itemValue !== undefined ? [itemValue] : [];
    } else {
      val = itemValue;
    }

    this.selectedItemValue = structuredClone(itemValue);
    this.$emit("input", val);
    this.$emit("change", val);

    this.pussOption = false;
  }

  giveMeClass(itemValue: unknown): string {
    if (this.selectedItemValue == itemValue) {
      return "itemSelectSelected_PFormSelect";
    } else {
      return "itemSelect_PFormSelect";
    }
  }
  open(): void {
    if (!this.disabled) {
      this.pussOption = !this.pussOption;
    }
  }
}

export default PFormSelect;
</script>
<style lang="scss" scoped>
.containerSelect_PFormSelect {
  cursor: pointer;
  &.disabled {
    cursor: initial;
  }
}
.label_PFormSelect {
  line-height: 1.23;
  color: #6f6f6f;
  min-height: 16px;
  padding-bottom: 0.5rem;
  font-size: 12px;
}

.inputSelect_PFormSelect_primary {
  display: flex;
  justify-content: space-between;
  border-radius: 4px;
  border: solid 1px #e4e4e4;
  background-color: #fafafa;
  padding: 12px 10px 12px 10px;
  color: #807f7f;
  width: 100%;
  white-space: nowrap;
  height: 45px;

  & > div {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.inputSelect_PFormSelect_withoutBox {
  display: flex;
  justify-content: space-between;
  border: none;
  width: 100%;
  white-space: nowrap;
  font-size: 14px;
  color: #808080;
  font-weight: bold;
}

.inputSelect_PFormSelect_button {
  display: flex;
  justify-content: space-between;
  object-fit: contain;
  border-radius: 16px;
  border: solid 1px #e8e8e8;
  background-color: #fff;
  font-size: 12px;
  line-height: 1.33;
  color: #6f6f6f;
  padding: 6px 12px;
  align-items: center;
  white-space: nowrap;
  height: 32px;
  margin-left: 10px;
}

.icon_PFormSelect {
  margin-right: 8px;
  margin-top: -3px;
}

.optionsSelect_PFormSelect {
  display: flex;
  flex-direction: column;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}

.itemSelect_PFormSelect,
.itemSelectSelected_PFormSelect,
.filter_options {
  padding: 0 1rem;
  border-bottom: solid 1px rgba(151, 151, 151, 0.13);
  object-fit: contain;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 3;
  letter-spacing: normal;
  white-space: nowrap;
}

.itemSelectSelected_PFormSelect {
  color: #d7b000;
}

.itemSelect_PFormSelect:hover {
  background-color: rgba(151, 151, 151, 0.13);
}

.expand_moreSelect_PFormSelect_primary {
  color: #6f6f6f;
}

.expand_moreSelect_PFormSelect_button span {
  color: #d7b000;
  font-size: 18px !important;
  margin-top: 4px;
  margin-left: 5px;
}

.borderSelected_PFormSelect {
  border: solid 1px #d7b000;
}

.p_form_invalid_feedback {
  color: #dc3545;
  font-size: 0.7rem;
}
.filter_options {
  border: 0 none;
}
.p_input_search {
  width: 100%;
  min-width: 200px;
}
</style>
